export const ourValues = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "100% Focused",
        img: "/images/newLanding/value1.svg",
        body: "Zonado is 100% dedicated to Commercial Real Estate and Sale of Business. We focus with the goal of bringing the best value and experience to our users."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Quality listings",
        img: "/images/newLanding/value2.svg",
        body: "Our team closely and regularly monitors all posts on Zonado to ensure we are providing our users with legitimate and quality listings."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Direct communication",
        img: "/images/newLanding/value3.svg",
        body: "Get right to the source by speaking directly to the seller, buyer or listing agent. No more multiple parties and broken telephone to get information."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Full transparency",
        img: "/images/newLanding/value4.svg",
        body: "CRE is infamous for being a black box and we are changing that. At Zonado, we are focused on being transparent and sharing all required information with the right parties. "
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Data privacy & protection",
        img: "/images/newLanding/value5.svg",
        body: "We only require minimum amount of personal information necessary for interaction on Zonado. We don’t sell it to third parties or share it for promotional reasons."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Seamless experience",
        img: "/images/newLanding/value6.svg",
        body: "Zonado allows buyers and sellers to reach the right audience, verify information, sign NDA’s all on one platform to ensure seamless experience for all users."
    },
]

export const profileData = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        name: "Harjaap Singh",
        position: "Co-Founder, Tech Lead",
        bio: "Equally passionate about software and commercial real estate, Harjaap leads product development at Zonado. His focus is to take away the pain points with the current method of transaction and elevate it into a seamless experience. ",
        img: "/images/newLanding/harjaap.png",
        linkedin: "harjaapsinghmakkar"
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        name: "Suhavi Makkar",
        position: "Co-Founder, Marketing Lead",
        bio: "As a second time founder with an MBA from Queen’s University, Suhavi brings years of experience of turning large portfolios into multi-million-dollar contracts. At Zonado, her focus is being in-tune with customer needs and building a platform that provides true value.",
        img: "/images/newLanding/suhavi.jpeg",
        linkedin: "suhavimakkar"
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        name: "Crystal Faurillo",
        position: "Content Developer",
        bio: "Crystal brings a great mix of experience working in various industries within the customer experience area. With that, she has an innate ability to connect with users, truly understand what they are looking for and provide solutions that add true value.",
        img: "/images/newLanding/crystal.png",
        linkedin: "crystalgayfaurillo"
    },
]
// bio: "loading",